import { push } from "connected-react-router";
import { useCopyToClipBoard } from "hooks/useCopyToClipBoard";
import Avatar from "pages/_components/Avatar";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool, shape, string } from "prop-types";
import React from "react";
import { actions as contactActions } from "reducers/contactDestination";
import useTransferByCbu from "../hooks/useTransferByCbu";

const ContactItem = ({ contact, isDesktop }) => {
    const { handleOtherTransfer } = useTransferByCbu();

    const { dispatch, handleCopyToClipBoard } = useCopyToClipBoard(
        isDesktop,
        "transfer.frequentDestinations.textCopy",
        contact,
    );

    const options = [
        {
            text: "frequentDestinations.contextMenu.transfer",
            textType: "I18N",
            func: () => handleOtherTransfer(contact),
        },
        {
            text: "frequentDestinations.contextMenu.modify",
            textType: "I18N",
            func: () => {
                dispatch(push(`/contactDestination/modify/${contact.idFrequentDestination}`));
            },
        },
        {
            text: "frequentDestinations.contextMenu.delete",
            textType: "I18N",
            func: () => {
                dispatch(
                    contactActions.deleteFrequentDestinationPreviewRequest({
                        idFrequentDestination: contact.idFrequentDestination,
                    }),
                );
            },
        },
        {
            text: "frequentDestinations.contextMenu.share",
            textType: "I18N",
            func: () => handleCopyToClipBoard("FrequentDestinations"),
        },
    ];

    return (
        <>
            <GridTable.Data className="avatar-name ellipsis m-auto">
                <Avatar
                    user={{
                        userFullName: contact.name,
                        defaultAvatarId: 0,
                        email: contact.recipientEmail,
                    }}
                />
                <CustomText text={contact.name} textType="TEXT" className="contact-name ellipsis" />
            </GridTable.Data>
            <GridTable.Data className="ellipsis cbucvu">
                <CustomData
                    dataClass="ellipsis"
                    titleText="transfer.frequentDestination.cbucvu"
                    titleTextType="I18N"
                    valueText={contact.cbu}
                    valueClass="ellipsis"
                />
            </GridTable.Data>
            <GridTable.Data className="document ellipsis">
                <CustomData
                    titleText="transfer.frequentDestination.document"
                    titleTextType="I18N"
                    valueText={`${contact.recipientDocumentType} ${contact.recipientDocumentNumber}`}
                    dataClass="ellipsis"
                    valueClass="ellipsis"
                />
            </GridTable.Data>

            <GridTable.Data className="menu">
                {options.length > 0 && (
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                )}
            </GridTable.Data>
            <GridTable.Data className="recipientName ellipsis">
                <CustomData
                    titleText="transfer.frequentDestination.recipientName"
                    titleTextType="I18N"
                    valueText={contact.recipientName}
                    dataClass="ellipsis"
                    valueClass="ellipsis"
                />
            </GridTable.Data>
            <GridTable.Data className="recipientEmail ellipsis">
                <CustomData
                    titleText="transfer.frequentDestination.recipientEmail"
                    titleTextType="I18N"
                    valueText={contact.recipientEmail}
                    dataClass="ellipsis"
                    valueClass="ellipsis"
                />
            </GridTable.Data>
        </>
    );
};

ContactItem.propTypes = {
    isDesktop: bool.isRequired,
    contact: shape({
        name: string,
        recipientName: string,
        recipientDocumentType: string,
        recipientDocumentNumber: string,
        cbu: string,
        recipientEmail: string,
    }).isRequired,
};

export default ContactItem;
